import DescriptionPaneEntry from "./DescriptionPaneEntry";

export default DescriptionPaneEntry;
export { DescriptionPaneEntry };
